import {configureStore, combineReducers} from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import {persistReducer, createTransform} from 'redux-persist';
import {ProfileApi} from '../pages/Profile/Profile.api';
import profile from '../pages/Profile/Profile.slice';
import {CompaniesApi} from '../pages/Companies/Companies.api';
import {HomeApi} from '../pages/Home/Home.api';
import {TariffsPageApi} from '../pages/TariffsPage/TariffsPage.api';
import {PayApi} from '../pages/Pay/Pay.api';
import app from './app.slice';

const rootReducer = combineReducers({
    app,
    profile,
    [ProfileApi.reducerPath]: ProfileApi.reducer,
    [CompaniesApi.reducerPath]: CompaniesApi.reducer,
    [HomeApi.reducerPath]: HomeApi.reducer,
    [TariffsPageApi.reducerPath]: TariffsPageApi.reducer,
    [PayApi.reducerPath]: PayApi.reducer,
});

const appBackendAvailableTransform = createTransform(
  (inboundState: any) => inboundState,
  (outboundState: any) => ({...outboundState, backendAvailable: true}),
  {whitelist: ['app']}
);

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    transforms: [appBackendAvailableTransform],
    blacklist: [HomeApi.reducerPath, CompaniesApi.reducerPath, ProfileApi.reducerPath, TariffsPageApi.reducerPath, PayApi.reducerPath, 'tires', 'disks']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const getPreloadedState = () => ({
    app: {
        token: localStorage.getItem('token'),
        backendAvailable: true,
    },
});

const authMiddleware = (store: any) => (next: any) => (action: any) => {
    const result = next(action);

    if (action.type === 'auth/setToken') {
        localStorage.setItem('token', action.payload);
    }


    return result;
};

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
          serializableCheck: false,
      }).concat(authMiddleware)
        .concat(
          // logger,
          CompaniesApi.middleware,
          ProfileApi.middleware,
          HomeApi.middleware,
          TariffsPageApi.middleware,
          PayApi.middleware
        ),
    preloadedState: getPreloadedState() as any,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
